import { z } from "zod";

export const backofficeFindPilotComponentsResponseSchema = z
  .object({
    brand: z.string(),
    name: z.object({
      id: z.number(),
      description: z.string(),
    }),
    note: z.string().nullable(),
    serial: z.string().nullable(),
  })
  .array();

export type BackofficeFindPilotComponentsResponse = z.infer<typeof backofficeFindPilotComponentsResponseSchema>;
